import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useLookups, useSearch } from "@/lib/lookups";
import { LookupBox } from "./LookupBox";

/** UK address finder: a postcode or the first line in, the full address out. Hidden until the key is set. */
export function AddressLookup({ onPick, testId = "address-lookup", className }) {
  const { address } = useLookups();
  const [q, setQ] = useState("");
  const { items, busy, error } = useSearch(address ? "/lookup/addresses" : null, q, 3);
  const [loading, setLoading] = useState(false);
  if (!address) return null;

  const pick = async (it) => {
    setLoading(true);
    try {
      const r = await api.get(`/lookup/addresses/${encodeURIComponent(it.id)}`);
      setQ("");
      onPick(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't fetch that address — type it in");
    } finally { setLoading(false); }
  };

  return (
    <LookupBox label="Find the address" hint="postcode or first line" placeholder="e.g. SW1A 2AA"
               value={q} onChange={setQ} items={items} busy={busy || loading} error={error} onPick={pick}
               testId={testId} className={className} render={(it) => <span>{it.suggestion}</span>} />
  );
}
